module.exports = __webpack_public_path__ + "img/game-feature3.9fe8c9b3.png";